var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CommonMoreBgColor"},[(this.$store.state.moreColor)?_c('sketch-picker',{model:{value:(_vm.moreColors),callback:function ($$v) {_vm.moreColors=$$v},expression:"moreColors"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }